import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "section-content" }
const _hoisted_4 = {
  key: 0,
  class: "report-chart"
}
const _hoisted_5 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Watermark = _resolveComponent("Watermark")!
  const _component_OutlierChart = _resolveComponent("OutlierChart")!
  const _component_OutlierSectionsChart = _resolveComponent("OutlierSectionsChart")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Watermark, { isSampleReport: _ctx.isSampleReport }, null, 8, ["isSampleReport"]),
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section" }, [
          _createElementVNode("div", { class: "section-title" }, [
            _createElementVNode("div", { class: "section-badge" }),
            _createTextVNode(" Data Quality ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, " The pie charts below indicate that " + _toDisplayString(_ctx.getMembersAnalysed) + "% of the data set (" + _toDisplayString(_ctx.data.totalMemberCount) + " members) received was analysed and scored, " + _toDisplayString(_ctx.getOutlierShorContib) + "% (" + _toDisplayString(_ctx.data.outlierGroups['Short Contribution History'] || '0') + " members) had contribution history of less than 12 months and hence were not scored, while " + _toDisplayString(_ctx.getOutlierPercent) + "% (" + _toDisplayString(_ctx.outlierCount) + " members) were deemed outliers. The outliers are then segregated into various categories to determine the underlying reasons behind the suspect data. It is recommended to investigate the outlier profiles individually for data cleansing purposes. ", 1)
        ]),
        (_ctx.data && _ctx.data.outliers && !_ctx.fetchingOutliers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_OutlierChart, {
                data: _ctx.data,
                memberAnalysedPercent: _ctx.getMembersAnalysed,
                outlierPercent: _ctx.getOutlierPercent,
                providerId: _ctx.providerId,
                isSampleReport: _ctx.isSampleReport
              }, null, 8, ["data", "memberAnalysedPercent", "outlierPercent", "providerId", "isSampleReport"]),
              _createVNode(_component_OutlierSectionsChart, {
                data: _ctx.data,
                providerId: _ctx.providerId,
                isSampleReport: _ctx.isSampleReport
              }, null, 8, ["data", "providerId", "isSampleReport"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}